import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Alert,
  AlertTitle,
  useTheme,
} from "@mui/material";

interface SizingToolActionsProps {
  analyzing: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  isValid?: boolean;
  disableAnalyze?: boolean;
}

export const SizingToolActions: React.FC<SizingToolActionsProps> = ({
  analyzing,
  onCancel,
  onSubmit,
  isValid = true,
  disableAnalyze = false,
}) => {
  const theme = useTheme();
  const analyzeDisabled = analyzing || !isValid || disableAnalyze;
  return (
    <Box
      sx={{
        borderTop: "1px solid #EDEDED",
      }}
    >
      {analyzing && (
        <Alert
          severity="info"
          sx={{
            mb: 2,
            mt: 2,
            borderRadius: "8px",
            "& .MuiAlert-message": {
              fontSize: "14px",
            },
          }}
        >
          <AlertTitle sx={{ fontWeight: 600, mb: 0.5, fontSize: "14px" }}>
            Analyzing your data…
          </AlertTitle>
          This can take a few minutes. Please, keep this window open—don't
          refresh or leave the page.
        </Alert>
      )}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          pt: 2,
          pb: 1,
          width: "100%",
        }}
      >
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            flex: 1,
            height: 48,
            fontWeight: 600,
            fontSize: 16,
            border: "1px solid #0076CE",
            color: "#0076CE",
            background: "#fff",
            borderRadius: 0,
            textTransform: "none",
            "&:hover": {
              border: "1px solid #0076CE",
              background: "#f8f9ff",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          sx={{
            flex: 1,
            height: 48,
            fontWeight: 600,
            fontSize: 16,
            background: "#0076CE",
            color: "#fff",
            borderRadius: 0,
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              background: "#0056a3",
              boxShadow: "none",
            },
            "&:disabled": {
              background: theme.palette.customBackground.disabled,
              color: theme.palette.sizingTool.neutral.textSecondary,
            },
          }}
          disabled={analyzeDisabled}
        >
          {analyzing ? <CircularProgress size={24} /> : "Analyze"}
        </Button>
      </Box>
    </Box>
  );
};

export default SizingToolActions;
